export default __webpack_public_path__ + "static/media/Genesis.fcd2447e.gif";